export const adminRouteAbsolute = {
    login: '/login',
    dashboard: '/dashboard',
    lessons: '/lessons',
    classes: '/classes'
};
